__turbopack_context__.v({
  "bannerContent": "VioBanner-module__wSLvGG__bannerContent",
  "blurredGradient": "VioBanner-module__wSLvGG__blurredGradient",
  "descriptionText": "VioBanner-module__wSLvGG__descriptionText",
  "logoWrapper": "VioBanner-module__wSLvGG__logoWrapper",
  "poweredByText": "VioBanner-module__wSLvGG__poweredByText",
  "vioBannerContainer": "VioBanner-module__wSLvGG__vioBannerContainer",
  "vioLogo": "VioBanner-module__wSLvGG__vioLogo",
});
